module.exports = __webpack_public_path__ + "static/media/mohren-logo.841dbcc8.svg";